export const MAX_RECORD_FOLDERS_LIMIT = 1000;
